import React from 'react'
import { Typography, Grid} from '@material-ui/core'
import useStyles from '../Styles'

export default function Contact(){
    const useStyle = useStyles();
    return(
        <Grid container justifyContent='center' alignItems='center' className={useStyle.portContainer}>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <Typography variant='h4' align='center'>
                    Hi There~
                </Typography>
                <Typography variant='h6' align='center'>
                    Clicking here means that it occurs on you to contact me
                </Typography>
                <Typography variant='h6' align='center'>
                    I am really grateful for that, and you can contact me through down here
                </Typography>
                <Typography variant='body2' align='center'>
                    It's okay to even just saying hi (^.^)
                </Typography>
            </Grid>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <Grid container justifyContent='center' alignItems='center'>
                    <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                        <Typography variant='h6' align='left'>
                            Email: <br /><a href="mailto:kevinnugrohos93@gmail.com">kevinnugrohos93@gmail.com</a>
                        </Typography>
                    </Grid>
                    <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                        <Typography variant='h6' align='left'>
                            Phone: <br />(+886) 908 480 474
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}